import * as React from 'react';
import { BaSeParagraph, BaSeButton, BaSeTheme } from '@base/react';

export const EmpresaInativaModal = ({
  closeModal,
  onVincularEmpresa,
  onContinue,
}) => {
  const handleVincularEmpresa = () => {
    if (onVincularEmpresa) {
      onVincularEmpresa();
      closeModal();
    }
  };

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
      closeModal();
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexFlow: 'column',
          gap: 24,
        }}
      >
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          Você está acessando os dados de uma empresa que consta como inativa.
          Essa empresa pode ter sido baixada ou ter pendências. Tente vincular
          novamente essa empresa em seu cadastro e, caso esteja ativa, abra um
          chamado no fale conosco do Sebrae.
        </BaSeParagraph>

        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          Fluxo de caixa de empresa inativa não pode ser editado.
        </BaSeParagraph>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <BaSeButton
            value="Vincular novamente"
            onClick={() => handleVincularEmpresa()}
          />
          <BaSeButton
            type="secondary"
            value="Continuar"
            onClick={() => handleContinue()}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
